import { NavLink } from 'react-router';

import { cx } from '../lib/cx.ts';
import { NAV_ITEMS } from './nav.ts';

/** Desktop navigation. Hidden below 900px, where the tab bar takes over. */
export function SideRail() {
  return (
    <div
      className={cx(
        'fixed inset-y-0 left-0 z-40 hidden w-rail flex-col gap-6',
        'border-r border-line bg-surface px-4 py-6 rail:flex',
      )}
    >
      <div className="px-2 text-sm font-strong tracking-wide text-muted uppercase">ICULogbook</div>

      <nav aria-label="Main">
        <ul className="flex flex-col gap-1">
          {NAV_ITEMS.map(({ to, label, Icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  cx(
                    'flex min-h-touch items-center gap-3 rounded-md px-3',
                    'text-base font-medium transition-colors duration-(--ui-duration-fast)',
                    isActive
                      ? 'bg-accent-quiet text-accent'
                      : 'text-muted hover:bg-surface-raised hover:text-text',
                  )
                }
              >
                <Icon className="size-5" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
